<template>
    <b-container >
        <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
        <b-alert :show = "showDismissibleAlert" dismissible 
            @dismissed="showDismissibleAlert=false"
            :variant="variant">
            {{alertText}}
        </b-alert>

        <div>
            <b-row class="justify-content-md-center">
                <b-col md="12" sm="12" class="mt-2">
                    <p style="font-size: 17px;color:#2284ab;">B-Form Charges Payment</p>
                    <p></p>
                    <p style="font-size: 0.875rem;">B-Form Chanrges to be Paid.</p>
                    <!-- <p style="font-size: 0.875rem;">The Board Selected by You is     : <strong>{{board.board}}</strong></p> -->
                    <!-- <p style="font-size: 0.875rem;">Please click 'Next' if the information is correct.</p>
                    <p><b-btn class="mt-2" size="sm" variant="warning" @click="CalculateFees">Next</b-btn></p> -->

                    <div style="padding: 10px;
                            border: 2px solid #c4c6be;
                            border-radius: 15px;" v-if="showdtls">
                        <span style="font-size: 0.875rem;">Please make online payment, as below, towards registration.
                        </span><br/><br/>
                            <b-row>
                              <b-col md="4" sm="1"></b-col>
                              <b-col md="2" sm="5" style="font-size: 0.875rem;"><strong>Details</strong></b-col>
                              <b-col md="2" sm="5" style="text-align:right;font-size: 0.875rem;"><strong>Amount</strong></b-col>
                              <b-col md="4" sm="1"></b-col>
                            </b-row>
                            <b-row>
                              <b-col md="4" sm="1"></b-col>
                              <b-col style="font-size: 0.875rem;">B-Form Charges</b-col>
                              <b-col style="text-align:right;font-size: 0.875rem;">&#8377; {{fees}}</b-col>
                              <b-col md="4" sm="1"></b-col>
                            </b-row>
                            <!-- <b-row>
                              <b-col md="4" sm="1"></b-col>
                              <b-col style="font-size: 0.875rem;">GST</b-col>
                              <b-col style="text-align:right;font-size: 0.875rem;">&#8377; {{gst}}</b-col>
                              <b-col md="4" sm="1"></b-col>
                            </b-row> -->
                            <!-- <b-row>
                              <b-col md="4" sm="1"></b-col>
                              <b-col style="font-size: 0.875rem;">Transaction Charges</b-col>
                              <b-col style="text-align:right;font-size: 0.875rem;">&#8377; {{TransactionCharges}}</b-col>
                              <b-col md="4" sm="1"></b-col>
                            </b-row> -->
                            <b-row>
                              <b-col md="4" sm="1"></b-col>
                              <b-col style="font-size: 0.875rem;"><strong>Total</strong></b-col>
                              <b-col style="text-align:right;font-size: 0.875rem;"><strong>&#8377; {{total}}</strong></b-col>
                              <b-col md="4" sm="1"></b-col>
                            </b-row>

                            <span style="font-size: 0.875rem;">Clicking the pay now button will navigate you to a secure payment site. On successful transaction you will be redirected back to the 'Security Guards Board' site. </span>
                            <p style="font-size: 1rem;color:red">*Payment Gateway Charges will be additional and as applicable. </p>
                    </div>
                </b-col>
            </b-row>
             <b-row class="mt-2 justify-content-md-center">
                <b-col style="text-align:right">
                <!-- <b-button type="submit" small variant="primary">Make Payment</b-button> -->
                <!-- <b-button type="reset" small variant="danger">Reset</b-button> -->
                <b-form method='POST' action='https://pgi.billdesk.com/pgidsk/PGIMerchantPayment'>        
                    <input type="hidden" name='msg' :value="payLoad">
                    <b-button type="submit" variant="primary" v-if="showdtls">Submit</b-button>
                </b-form>
                </b-col>
            </b-row>
        </div>
    </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import * as _ from "lodash";

export default {
  components: { Spinner },
  data() {
    return {
      msg: "",
      fees: 100.0,
      securityID: "",
      token: "",
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      showdtls: false,
      form: {
        BoardID: "",
        FeesType: "FormB Receipt",
        CategoryTypeID: "00000000-0000-0000-0000-000000000000"
      },
      total: 100,
      gst: 0,
      payLoad: "",
      payment: {
        PaymentID: "",
        EventID: "",
        BoardID: "",
        UserID: "",
        TransactionStatus: "Pending",
        TransactionType: "FormB Receipt",
        TransactionAmount: 100.0,
        TransactionCharges: 0.0,
        Currency: "INR",
        MerchantID: "",
        PaymentStatus: false,
        UserName: "",
        Purpose: "Registration of Existing Security Guards"
      }
    };
  },
  methods: {
    CalculateFees() {
      let pmtobj = this.$store.getters.getPmtObj;
      this.payment.BoardID = pmtobj.BoardID;
      this.payment.EventID = pmtobj.ApplicationID;
      this.form.BoardID = pmtobj.BoardID;

      let promise = apis.getFees(this.form);

      promise
        .then(response => {
          if (response.status == 200) {
            this.fees = response.body.FeesAmount.toFixed(2);
            this.gst = (this.fees * response.body.TaxRatePercent / 100).toFixed(
              2
            );
            this.total = (
              this.fees *
              (100 + response.body.TaxRatePercent) /
              100
            ).toFixed(2);

            var userinfo = this.$store.getters.loggedUser;
            this.payment.UserID = userinfo.UserId;
            this.payment.TransactionAmount = this.total;
            this.payment.UserName = userinfo.UserName;
            let promise2 = apis.getPmtRequest(this.payment);

            promise2
              .then(response => {
                //console.log(response);
                if (response.status == 200) {
                  localStorage.setItem("userinfo", JSON.stringify(userinfo));
                  localStorage.setItem("token", response.body.token);

                  //console.log(response.body.token);
                  this.payLoad = response.body.msg;
                  this.$store.dispatch("setPrintPmt", false);
                  //console.log("Payload", this.payLoad);
                  this.showdtls = true;
                } else {
                  this.alertText = response.body;
                  this.variant = "warning";
                  this.showDismissibleAlert = true;
                }
              })
              .catch(err => {
                this.alertText = err.body;
                this.showDismissibleAlert = true;
                this.variant = "danger";
              });

            this.isLoading = false;
          } else {
            this.alertText =
              "Error in calculating the Fees amount. Please try again after some time.";

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText =
            "Error in calculating the Fees amount. Please try again after some time.";
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    }
  },
  mounted() {
    this.isLoading = true;
    this.CalculateFees();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/RegistrationDetails/BFormPaymentBD.vue